import { render, staticRenderFns } from "./ModalDeleteSave.vue?vue&type=template&id=1ec8cabe"
import script from "./ModalDeleteSave.vue?vue&type=script&lang=js"
export * from "./ModalDeleteSave.vue?vue&type=script&lang=js"
import style0 from "./ModalDeleteSave.vue?vue&type=style&index=0&id=1ec8cabe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports